import React, {useState} from "react";
import styles from "./your-birthtime.module.css";
import {Page} from "../../components/page/page";
import {Link} from "react-router-dom";
import {DateTimeButton} from "../../../../components/date-time-button/date-time-button";
import {useDispatch, useSelector} from "react-redux";
import {setBirthTime} from "../../store/stateSlice";
import {updateProfile} from "../../../../api";
import {convertTo24Hour} from "../../../../util";
import { ReactComponent as CircleImg } from '../../images/circle.svg';

const leftFillNum = (num, targetLength) => {
  return num.toString().padStart(targetLength, "0");
}

const YourBirthTimePage = () => {
  const state = useSelector(store => store.future);
  const dispatch = useDispatch();
  const [selectedHour, selectHour] = useState(state.birthTime.hour || 12);
  const [selectedMinute, selectMinute] = useState(state.birthTime.minute || 0);
  const [selectedPeriod, selectPeriod] = useState(state.birthTime.period || "AM");

  const dateTimeButtonStyles = {
    color: 'rgb(0, 0, 0)',
    backgroundColor: 'rgb(255, 255, 255)',
    border: '1px solid rgb(218, 218, 218)',
    fontSize: '16px',
  };

  const buttonStyles = {
    backgroundColor: "rgb(33, 51, 112)",
    fontSize: '18px',
    boxShadow: 'none',
    borderRadius: '150px',
    position: "absolute",
    bottom: "110px",
      width: "90%",
      zIndex: "5",
      maxWidth: "500px",
      boxSizing: "border-box",
  };

  const handleContinue = () => {
    dispatch(
        setBirthTime({
          hour: parseInt(selectedHour),
          minute: parseInt(selectedMinute),
          period: selectedPeriod,
        })
    )
    updateProfile({
      land: "future",
      topicType: "birthTime",
      topic: "What is your time of birth?",
      answer: {
        hour: convertTo24Hour(parseInt(selectedHour), selectedPeriod),
        minute: parseInt(selectedMinute)
      }
    })
  }

  return (
    <Page
      title="What is your time of birth?"
      nextPageLink="../your-birthplace"
      onContinue={handleContinue}
      buttonStyles={buttonStyles}
      currentStep="10"
    >
      <p className={styles.subtitle}>We need this to determine the planetary placements at the time of your birth. If you don’t know this information, you can still get plenty of useful insights.</p>
      <div className={styles.container_page}>
        <div className={styles.buttons_flex_container}>
          <div className={styles.time_button_container}>
            <DateTimeButton styles={styles.button} value={selectedHour} dateTimeButtonStyles={dateTimeButtonStyles}  onChange={(e) => selectHour(e.target.value)}>
              {[...Array(12)].map((el, i) => (
                <option value={leftFillNum(i + 1, 2)}>{leftFillNum(i + 1, 2)}</option>
              ))}
            </DateTimeButton>
          </div>
          <div className={styles.time_button_container}>
            <DateTimeButton styles={styles.button} value={selectedMinute} dateTimeButtonStyles={dateTimeButtonStyles} onChange={(e) => selectMinute(e.target.value)}>
              {[...Array(60)].map((el, i) => (
                <option value={leftFillNum(i, 2)}>{leftFillNum(i, 2)}</option>
              ))}
            </DateTimeButton>
          </div>
          <div className={styles.time_button_container}>
            <DateTimeButton styles={styles.button} value={selectedPeriod} dateTimeButtonStyles={dateTimeButtonStyles} onChange={(e) => selectPeriod(e.target.value)}>
              <option>AM</option>
              <option>PM</option>
            </DateTimeButton>
          </div>
        </div>
      </div>
        <Link to="../your-birthplace">
            <div className={styles.idk_link}>
                I don't know
            </div>
        </Link>
        <CircleImg className={styles.page_image} width="100%" height="100%" />
    </Page>
  );
};

export { YourBirthTimePage };
